import { render, staticRenderFns } from "./PatientDiagnosis.vue?vue&type=template&id=9c9649d0&scoped=true&"
import script from "./PatientDiagnosis.vue?vue&type=script&lang=ts&"
export * from "./PatientDiagnosis.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDiagnosis.vue?vue&type=style&index=0&id=9c9649d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9649d0",
  null
  
)

export default component.exports